import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.1677 41.0908C73.1677 41.0908 59.6077 34.2008 55.5577 29.4708C51.0577 24.2108 51.2577 1.5708 51.2577 1.5708H38.8378C38.8378 1.5708 39.1477 24.3208 34.5377 29.4708C29.6477 34.9308 16.9277 40.8908 16.9277 40.8908C23.1177 55.4708 35.5177 59.1908 45.0477 59.1908C54.5777 59.1908 66.9677 55.6808 73.1677 41.0908Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.698 57.9907C85.138 45.9807 81.488 42.7407 76.818 40.3907C74.518 39.2307 59.988 31.5107 59.988 31.5107C59.988 31.5107 55.0779 38.4507 45.3979 38.4507C35.7179 38.4507 30.098 31.5107 30.098 31.5107C30.098 31.5107 15.6579 39.1807 13.2579 40.3907C8.58793 42.7407 5.02805 46.3707 3.37805 57.9907C1.89805 69.0507 1.45801 71.8107 1.45801 71.8107H88.608C88.618 71.8107 87.998 68.2907 86.698 57.9907Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.1484 34.3208C24.1484 34.3208 30.3985 44.5608 44.1285 44.5608C59.3185 44.5608 65.9285 34.3208 65.9285 34.3208"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        opacity="0.8"
        d="M55.8582 70.7208C58.8482 66.8908 61.2981 62.3808 61.2981 57.8708C61.2981 53.0208 57.3681 49.0908 52.5181 49.0908C49.3581 49.0908 46.5881 50.7708 45.0481 53.2808C43.4981 50.7708 40.7381 49.0908 37.5681 49.0908C32.7181 49.0908 28.7881 53.0208 28.7881 57.8708C28.7881 62.4308 31.1881 66.9108 34.1381 70.7108"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.0426"
          y1="42.7448"
          x2="45.0426"
          y2="8.7121"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
